import React from 'react';
import { Card, Typography, Button, Switch, Popconfirm } from 'antd';
import { Edit, Trash2 } from 'lucide-react';
import { TextBookingWorkflowProps } from '@/interfaces/ICalendarWorkflows';

const { Text } = Typography;

export const TextBookingWorkflow: React.FC<TextBookingWorkflowProps> = ({
	workflow,
	workflowNumber,
	onEdit,
	onDelete,
}) => {
	return (
		<Card className="border-2 shadow-md">
			<div className="flex flex-col">
				<div className="flex justify-between items-start mb-6">
					<div className="mb-4">
						<Text strong className="text-lg text-gray-800">
							Workflow {workflowNumber}
						</Text>
					</div>
					<div className="flex gap-3">
						{onEdit && (
							<Button
								type="default"
								icon={<Edit size={16} />}
								onClick={() => onEdit(workflow)}
								className="border-blue-300 text-blue-600 hover:bg-blue-50"
								size="small"
							>
								Edit
							</Button>
						)}
						{onDelete && (
							<Popconfirm
								title="Delete Workflow"
								description="Are you sure you want to delete this workflow?"
								onConfirm={() => onDelete(workflow)}
								okText="Yes"
								cancelText="No"
								placement="left"
							>
								<Button
									type="default"
									danger
									icon={<Trash2 size={16} />}
									className="border-red-300 text-red-600 hover:bg-red-50"
									size="small"
								>
									Delete
								</Button>
							</Popconfirm>
						)}
					</div>
				</div>

				<div className="space-y-4">
					<div className="border-b pb-4">
						<Text strong className="block mb-3 text-gray-700">
							Enable Short URLs
						</Text>
						<Switch checked={workflow.shortURLEnabled} disabled size="default" />
					</div>

					<div className="border-b pb-4">
						<Text strong className="block mb-3 text-gray-700">
							Scenario Description
						</Text>
						<div className="bg-gray-100 p-4 rounded-lg text-sm text-gray-800 border">
							{workflow.description || 'No description'}
						</div>
					</div>

					<div className="border-b pb-4">
						<Text strong className="block mb-3 text-gray-700">
							Text Message
						</Text>
						<div className="bg-gray-100 p-4 rounded-lg text-sm text-gray-800 border">
							{workflow.textMessage || 'No message configured'}
						</div>
					</div>

					{workflow.postExecutionPrompt && (
						<div className="border-b pb-4">
							<Text strong className="block mb-3 text-gray-700">
								What should the AI do next?
							</Text>
							<div className="bg-gray-100 p-4 rounded-lg text-sm text-gray-800 border">
								{workflow.postExecutionPrompt}
							</div>
						</div>
					)}

					<div className="pb-2">
						<Text strong className="block mb-3 text-gray-700">
							Ask before sending Text SMS
						</Text>
						<Switch checked={workflow.askForPermissionOnText} disabled size="default" />
					</div>
				</div>
			</div>
		</Card>
	);
};
